import { IConfig } from './'

export const ProductionConfig: IConfig = {
  // apiServerHost: 'api.ws.rc.okumo.to',
  apiServerHost: 'rc-api.waseda.getpa.net',
  // apiServerHost: 'response-collector-prod.herokuapp.com',
  // apiServerHost: 'api.app.jp.response-collector.app',
  apiServerPort: 443,
  apiServerTenant: location.host.split('.')[0],
  ssl: true,
  googleOAuthClientId: '768977675172-r7t1ri8jfergmkh8cfks00u4jalp8454.apps.googleusercontent.com',
  microsoftOAuthClientId: 'cf96ec32-5b1c-4900-83a7-6103c2554a04',
}



// WEBPACK FOOTER //
// ./src/config/production.ts